export const ApiBaseUrl = {
  ACCOUNTS: process.env.ACCOUNTS_API_URL,
}

export const ApiEndpoint = {
  DYNAMIC_FORMS: '/api/platform/v1/dynamic-forms',
}
